import React, { useState, useEffect } from 'react';
import Styles from './InterviewResult.module.scss';
import { PieChart, Pie, Cell } from 'recharts';
import ReplayIcon from '@mui/icons-material/Replay';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Tabs, Tab, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAPI } from 'components/lib';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';


ChartJS.register(ArcElement, Tooltip, Legend);

export function InterviewResult({ sessionId }) {
    const navigate = useNavigate();
    const [currentTab, setCurrentTab] = useState(0);
    const [sectionResults, setSectionResults] = useState(null);
    const data = useAPI(`/api/interview/${sessionId}/results`);
    
    useEffect(() => {
        if (data?.data) {
            const dataObj = data?.data
            const sortedObj = Object.keys(dataObj)
                .sort()
                .reduce((acc, key) => {
                    acc[key] = dataObj[key];
                    return acc;
                }, {});
            setSectionResults(sortedObj);
        }
    }, [data]);

    const getPieData = (section) => [
        { name: `${section} Score`, value: sectionResults[section]?.totalScore },
        { name: 'Remaining', value: 100 - sectionResults[section]?.totalScore },
    ];
    const getScoreColor = (score) => {
        if (score >= 90) return Styles.excellent;
        if (score >= 70) return Styles.good;
        if (score >= 50) return Styles.moderate;
        return Styles.needsImprovement;
    };

    return (
        <>
            {!sectionResults ? (
                <>
                    <LoadingBackdrop isOpen={!sectionResults} />
                </>
            ) : (

                <div className={Styles.resultContainer}>

                    {/* <div className={Styles.header}>
                        <h2 className={Styles.resultTitle}>Interview Practice Results</h2>
                    </div> */}
                    {/* <div className={Styles.divider}> */}
                    {/* <InterviewSections/> */}
                    <div>
                        <Box className={Styles.tabsContainer}>
                            <Tabs
                                value={currentTab}
                                onChange={(e, newValue) => setCurrentTab(newValue)}
                                aria-label="Interview Results Tabs"
                                variant="fullWidth"
                                className={Styles.tabs}
                            >
                                {Object.keys(sectionResults).map((section) => (
                                    <Tab key={section} label={section.charAt(0).toUpperCase() + section.slice(1)} className={Styles.tab} />
                                ))}
                            </Tabs>
                        </Box>

                        <div className={Styles.contentSection}>
                            <div className={Styles.donutChartContainer}>
                                <PieChart width={300} height={300}>
                                    <Pie
                                        data={getPieData(Object.keys(sectionResults)[currentTab])}
                                        cx={150}
                                        cy={150}
                                        innerRadius={100}
                                        outerRadius={140}
                                        startAngle={90}
                                        endAngle={450}
                                        dataKey="value"
                                    >
                                        <Cell
                                            key="score"
                                            fill={
                                                getScoreColor(sectionResults[Object.keys(sectionResults)[currentTab]].totalScore).includes(
                                                    'excellent',
                                                )
                                                    ? '#008037'
                                                    : getScoreColor(sectionResults[Object.keys(sectionResults)[currentTab]].totalScore).includes(
                                                        'good',
                                                    )
                                                        ? '#1450a0'
                                                        : getScoreColor(sectionResults[Object.keys(sectionResults)[currentTab]].totalScore).includes(
                                                            'moderate',
                                                        )
                                                            ? '#FFCE4E'
                                                            : '#FF1616'
                                            }
                                        />
                                        <Cell key="remaining" fill="#E0E0E0" />
                                    </Pie>
                                </PieChart>

                                <div className={Styles.scoreOverlay}>
                                    <span
                                        className={`${Styles.currentScore} ${getScoreColor(
                                            sectionResults[Object.keys(sectionResults)[currentTab]].totalScore,
                                        )}`}
                                    >
                                        {sectionResults[Object.keys(sectionResults)[currentTab]].totalScore}%
                                    </span>
                                </div>
                            </div>

                            <div className={Styles.progressBarsContainer}>
                                <h3 className={Styles.sectionTitle}>Detailed Breakdown</h3>
                                {Object.entries(sectionResults[Object.keys(sectionResults)[currentTab]].metrics).map(([key, value]) => (
                                    <div key={key} className={Styles.progressBarWrapper}>
                                        <div className={Styles.progressBarHeader}>
                                            <span className={Styles.detailLabel}>{key[0].toUpperCase() + key.slice(1)}</span>
                                            <span className={`${Styles.progressValue} ${getScoreColor(value)}`}>{value}%</span>
                                        </div>
                                        <div className={Styles.progressBarBackground}>
                                            <div className={`${Styles.progressBar} ${getScoreColor(value)}`} style={{ width: `${value}%` }} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    {/* </div> */}
                    <div className={Styles.practiceAgainButton}>
                        <AivagamButton
                            buttonText={
                                <span
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: '0.5em',
                                    }}
                                >
                                    <ReplayIcon fontSize="small" /> Practise Again
                                </span>
                            }
                            onClick={() => {
                                sessionStorage.clear(); // Clears all session storage data
                                localStorage.removeItem('sessionId'); // Remove sessionId from localStorage
                                localStorage.removeItem('questions'); // Remove questions from localStorage
                                navigate('/interview/topics'); // Navigate to interview topics
                            }}
                            classStyles={{ boxShadow: '0 3px 6px rgba(0, 0, 0, 0.3)' }}
                        />
                    </div>
                </div>
            )}
        </>
    );
}
